import { Component, Input } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

let nextId = 0;

@Component({
  selector: 'ukho-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
})
export class RadioComponent implements ControlValueAccessor {
  /**
   * The name of the radio button
   */
  @Input() name: string;

  /**
   * The checked value of the radio button
   */
  @Input() checked = false;

  /**
   * The disablement of the radio button
   */
  @Input() disabled = false;

  /**
   * The value of the radio button for use on selection within a radio group
   */
  @Input() value: any;

  /**
   * AUTOGENERATED
   * This is an auto-generated form-field ID
   */
  id = `ukho-radio-${++nextId}`;

  /**
   * @ignore
   */
  onChange = (checked: boolean) => {};

  /**
   * @ignore
   */
  onTouch = () => {};

  /**
   * @ignore
   */
  registerOnChange(fn: (checked: boolean) => void): void {
    this.onChange = fn;
  }

  /**
   * @ignore
   */
  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  /**
   * @ignore
   */
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * @ignore
   */
  writeValue(value: any): void {
    this.checked = !!value;
  }
}
